import React, { useState } from 'react';
import axios from '../../api/axios';
import '../../styles/loginPage.css';
import { useNavigate } from 'react-router-dom';
import { notify } from '../toast';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    try {
      setLoading(true);
      const response = await axios.post('/forgotPassword', { email });
      const res = response?.data;
      navigate('/reset', {
        state: {
          email
        }
      });

      notify('success', res?.success);
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
      setError(errorMessage);
    }
    finally {
      setLoading(false);
      setEmail('');
    }
  };

  return (
    <div className="body-login">
      <div className='login-container'>
        <h2>Forgot Password</h2>
        {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor='f-email'>Email</label>
            <input
              type="email"
              id='f-email'
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit">
            {loading ? <span className="spinner" /> : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
